


































import IconArrow, { colors } from "@/components/icons/IconArrow.vue";
import { eventBus, IModalPayload } from "@/lib/event-bus";
import anime from "animejs";
import { Component, Prop, Vue } from "vue-property-decorator";
import IQuestion from "../typings/IQuestion";

/**
 * Top-level navigation component used to indicate progress and allow visitors
 * to backtrack, advance, and reset the application.
 */
@Component({
  components: { IconArrow }
})
export default class ProgressBar extends Vue {
  @Prop({ default: "" }) private title!: string;

  private iconColors = colors;

  /**
   * Returns true if visitor can go to previous response.
   */
  private get canGoBack(): boolean {
    return this.currentQuestionIndex > 0 && this.canReset;
  }

  /**
   * Returns true if visitor can reset the application.
   */
  private get canReset(): boolean {
    return (
      this.$route.name === "capture" ||
      this.$route.name === "intro" ||
      this.$route.name === "survey" ||
      this.$route.name === "avatar"
    );
  }

  private get currentQuestionIndex(): number {
    return this.$store.getters.currentQuestionIndex;
  }

  /**
   * The progress bar's current progress level.
   */
  private get progress(): number {
    return this.$store.getters.progress;
  }

  private get questions(): IQuestion[] {
    return this.$store.getters.questions;
  }

  /**
   * Get the current question's format.
   */
  private get questionFormat(): string {
    if (
      this.questions.length <= 0 ||
      this.currentQuestionIndex > this.questions.length - 1
    )
      return "";
    return this.questions[this.currentQuestionIndex].format;
  }

  /**
   * Handles the request to go to the previous step.
   */
  private handleBack(): void {
    if (!this.canGoBack || anime.running.length > 0) return;
    this.$store.dispatch("undoResponse");
    this.$store.dispatch("decrementProgress");
  }

  /**
   * Handles the request to reset the application.
   */
  private handleReset(): void {
    const payload: IModalPayload = { component: "ModalReset" };
    eventBus.$emit("modal:open", payload);
  }
}
